/** Mirrors packages/domain free-trial / pricing constants for SPA copy. */
export const FREE_TRIAL_STREAMS = 3;
export const FREE_TRIAL_DAYS = 30;
export const FREE_TRIAL_ATTENDEES_PER_STREAM = 100;
export const ACTIVE_STREAM_PRICE_CENTS = 1000;
export const ATTENDEE_PRICE_CENTS = 5;
export const TRIAL_USAGE_WARNING_RATIO = 0.8;
/** Auto-created streams at or below this attendee count are free (paid accounts). */
export const AUTO_STREAM_FREE_ATTENDEE_LIMIT = 3;

export function formatCents(cents: number): string {
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: "USD",
  }).format(cents / 100);
}

export function trialUsageLevel(used: number): "ok" | "warning" | "exhausted" {
  if (used >= FREE_TRIAL_ATTENDEES_PER_STREAM) return "exhausted";
  if (used >= FREE_TRIAL_ATTENDEES_PER_STREAM * TRIAL_USAGE_WARNING_RATIO)
    return "warning";
  return "ok";
}
